//src/guards/authGuard.js
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CSRFService from '../services/csrfService';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, loading } = useSelector((state) => state.auth);
  const location = useLocation();

  useEffect(() => {
    const ensureCSRFToken = async () => {
      if (isAuthenticated) {
        try {
          // Ensure we have a valid CSRF token
          await CSRFService.getToken();
        } catch (error) {
          console.error('Failed to get CSRF token:', error);
        }
      }
    };

    ensureCSRFToken();
  }, [isAuthenticated]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthGuard;